import { format, parseISO } from 'date-fns';

export const formatDate = (dateString) => {
  return dateString ? format(parseISO(dateString), 'PPP') : '-';
};
